module.exports = __webpack_public_path__ + "staticcomp/img/content_1副本.d6b0e68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/1/content_1副本.jpg
// module id = Gf1G
// module chunks = 39